import { get, post, deleteRequest, patch } from 'utils/api';

export const getPreloadedCampaigns = (data) => {
  return get(`/preloaded-campaigns`, data);
};

export const getPreloadedCampaignById = (id) => {
  return get(`/preloaded-campaigns?id=${id}`);
};

export const addPreloadedCampaign = (data) => {
  return post(`/preloaded-campaigns`, data);
};

export const updatePreloadedCampaign = (data) => {
  const id = data.id;
  delete data['id'];
  return patch(`/preloaded-campaigns?id=${id}`, data);
};

export const deletePreloadedCampaign = (id) => {
  return deleteRequest(`/preloaded-campaigns?id=${id}`);
};

export const disbursePreloadedCampaign = (id) => {
  return post(`/preloaded-campaigns/${id}/disburse`, {});
};

export const preloadedCampaign = {
  getPreloadedCampaigns,
  getPreloadedCampaignById,
  addPreloadedCampaign,
  updatePreloadedCampaign,
  deletePreloadedCampaign,
  disbursePreloadedCampaign,
};
